import $ from "jquery";
import { each } from "lodash";
import Datawrapper from "lib/tc/datawrapper";
import Infographic from "lib/tc/infographic";
/* eslint-disable
    global-require,
    no-multi-assign,
    no-param-reassign,
    no-undef,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// TC.infographics is a utility which allows us to quickly identify, load and
// replace the exisiting infographics on a page.
//
// Usage:
//
//   Infographics = require("lib/tc/infographics")
//   Infographics.init(@$el)
//
// It also is the container for a global last scroll position used by
// the infographics to save and revert scroll positions.
let Infographics;

export default Infographics = {
  init(page, opts) {
    if (opts == null) { opts = {}; }
    this.offset = opts.offset || 0;
    const infographics = page.find("iframe.tc-infographic");

    each(infographics, (infographic, _) => {
      const id = $(infographic).attr("id");
      const src = $(infographic).attr("src");
      const height = $(infographic).attr("height");

      return new Infographic(id, src, { offset: this.offset, height });
    });

    const datawrappers = page.find("iframe.tc-infographic-datawrapper");
    return each(datawrappers, (infographic, _) => {
      const id = $(infographic).attr("id");
      return new Datawrapper(id);
    });
  },
};
